import moment from 'moment';
import tz from 'moment-timezone';
import isArray from 'lodash/isArray';

export const getLocalTimeZone = () => (
  tz.tz.guess()
  || 'America/New_York'
);

export const getDays = () => ([
  'SUN',
  'MON',
  'TUE',
  'WED',
  'THU',
  'FRI',
  'SAT',
]);

export const getTimeZoneOptions = () => (
  [
    'America/Anchorage',
    'America/Boise',
    'America/Chicago',
    'America/Denver',
    'America/Detroit',
    'America/Indianapolis',
    'America/Los_Angeles',
    'America/Louisville',
    'America/New_York',
    'America/Phoenix',
    'Pacific/Honolulu',
  ]
    .filter(zone => 
      zone.startsWith('America/') 
      && !zone.includes('Argentina')
      && !zone.includes('Antigua')
      && !zone.includes('Anguilla')
      && !zone.includes('Aruba')
      && !zone.includes('Araguaina')
      && !zone.includes('Asuncion')
      && !zone.includes('Atikokan')
    ).map(zone => ({
      label: zone,
      value: zone,
    }))
);

// Given an array of times, return true if and only if the times are all valid
// each time should conform to the form of {start_time: 'hh:mm a', end_time: 'hh:mm a'}
export const validateAvailabilityTimes = times => {
  if (!times || !isArray(times)) return false;
  const isValid = times.reduce((acc, {start_time, end_time}) => {
      const start = moment(start_time, 'hh:mm a');
      const end = moment(end_time, 'hh:mm a');
      const isValid = end.isAfter(start);
      return acc && isValid;
    }, true);
  return isValid;
};
